import React from 'react';
import Helmet from 'react-helmet';
import { Query, Mutation } from 'react-apollo';
import gql from 'graphql-tag';
import { toast } from 'react-toastify';

import { withAppStorage } from '../utils/appStorage';
import { TransitionWrapper } from '../components/TransitionWrapper';

import GenerateMetaTags from '../components/GenerateMetaTags';
import Breadcrumbs from '../components/Breadcrumbs';
import Article, { Title, Content } from '../components/Article';
import Cart from '../components/Cart';
import RegistrationNumberNotice from '../components/RegistrationNumberNotice';
import GuidanceNotice from '../components/GuidanceNotice';

import { dataLayer } from '../utils/window';

export const GET_CART = gql`
  query getCart($id: String!) {
    cart: getCart(id: $id) {
      id
      sumProducts
      sumShipping
      shippingDiscount
      products {
        price
        name
        productIndx
        part {
          id: Indx
          name: displayName
          stockNumber: Lagernummer
          images: Bilder
        }
      }
    }
  }
`;

export const REMOVE_PRODUCT_FROM_CART = gql`
  mutation removeProductFromCart($cartId: String!, $productIndx: String!) {
    removeProductFromCart(cartId: $cartId, productIndx: $productIndx) {
      id
      sumProducts
      sumShipping
      shippingDiscount
      products {
        price
        name
        productIndx
        part {
          id: Indx
          name: displayName
          stockNumber: Lagernummer
          images: Bilder
        }
      }
    }
  }
`;

export default withAppStorage(function CartPage({ appStorageData }) {
  return (
    <TransitionWrapper>
      <Helmet>
        {GenerateMetaTags({
          title: 'Handlekurv',
          description: 'Se produktene i din handlekurv.'
        })}
      </Helmet>

      <Breadcrumbs breadcrumbs={null} />

      <Article>
        <Title>Handlekurv</Title>

        <Content wide>
          <RegistrationNumberNotice />

          <Mutation mutation={REMOVE_PRODUCT_FROM_CART}>
            {(onRemoveProductFromCart, { loading, error }) =>
              (!appStorageData.cartId && <div />) || (
                <Query
                  query={GET_CART}
                  variables={{
                    id: appStorageData.cartId
                  }}
                >
                  {({ data, loading, error }) =>
                    (data &&
                      data.cart && (
                        <Cart
                          cart={data.cart}
                          onRemoveProductFromCart={(productIndx, part) => {
                            onRemoveProductFromCart({
                              variables: {
                                cartId: appStorageData.cartId,
                                productIndx
                              },
                              update: (store, { data: { cart } }) => {
                                let data = null;
                                try {
                                  data = store.readQuery({
                                    query: GET_CART,
                                    variables: { id: cart.id }
                                  });
                                } catch (e) { }

                                if (!data) {
                                  return;
                                }

                                data.cart = cart;

                                store.writeQuery({
                                  query: GET_CART,
                                  data,
                                  variables: { id: cart.id }
                                });
                              }
                            }).then(() => {
                              dataLayer.push({
                                'event': 'removeFromCart',
                                'ecommerce': {
                                  'remove': {
                                    'products': [{
                                      ...part,
                                      quantity: 1
                                    }]
                                  }
                                }
                              });

                              toast('Produkt fjernet fra handlekurven', {
                                position: 'bottom-right',
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true
                              });
                            });
                          }}
                        />
                      )) || <span />
                  }
                </Query>
              )
            }
          </Mutation>
        </Content>
      </Article>

      <GuidanceNotice />
    </TransitionWrapper>
  );
});
